import { createGlobalStyle } from 'styled-components';

import 'react-day-picker/dist/style.css';

import colors, { opacity } from './colors';

import { HIDDEN, NO_HEIGHT } from 'styles/commonClasses';

import iconsFontFace from 'styles/fonts/icons';

const GlobalStyles = createGlobalStyle<{ responsive?: boolean; darkMode?: boolean }>`
    ${iconsFontFace}

    html,
    body {
      height: 100%;
      width: 100%;
      margin: 0;
      padding: 0;
      // @ts-expect-error TS(2339): Property 'responsive' does not exist on type 'Them... Remove this comment to see the full error message
      min-width: ${(props) => (props.responsive ? '240px' : '1024px')};
      background-color: ${(props) => (props.darkMode ? colors.fleetDarkBlue : colors.white)};
    }

    body * {
      font-family: 'Open Sans', sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    #app {
      display: flex;
      flex-direction: column;
      min-height: 100%;
      position: relative;
    }

    input:focus,
    select:focus,
    textarea:focus,
    button:focus {
        outline: none;
    }

    input::placeholder {
      color: ${colors.inactive};
    }

    input[disabled],
    select[disabled],
    textarea[disabled] {
        opacity: 0.5;
    }

    .draggableStyle {
        z-index: 10;
        box-shadow: 0 1px 4px 0 ${colors.gray90};
        border: 1px solid ${colors.inactive};
        background-color: ${colors.white};

        i {
            opacity: 1;
        }
    }

    input[type="button" i],
    input[type="submit" i],
    input[type="reset" i],
    input[type="file" i]::-webkit-file-upload-button,
    button {
      cursor: pointer;
      background-color: transparent;
    }

    a {
      color: ${colors.highlight};
    }

    p {
        hyphens: auto;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    .${HIDDEN} {
      display: none !important;
    }

    .${NO_HEIGHT} {
      height: 0;
    }

    // React Google Autocomplete styles
    ${(props) =>
      props.darkMode &&
      `
      .pac-container {
        background-color: #161926;
      }
      .pac-logo {
        color: ${colors.white};
        }
      .pac-item {
        border-color: ${colors.fleetDarkBlue};
        color: ${opacity(colors.white, 0.6)};
      }
      .pac-item:last-child {
        border-bottom: 1px solid ${colors.fleetDarkBlue};
      }
      .pac-item:hover {
        background-color: ${opacity(colors.fleetOffGray, 0.2)}
      }
      .pac-item-query {
        color: ${colors.white};
      }
    `}
`;

export default GlobalStyles;
